import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltPresenceTooltipUserActiveWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-presence-tooltip-user-active-wireframe", __assign({}, transformedProps), children));
};
export default VeltPresenceTooltipUserActiveWireframe;
